// extracted by mini-css-extract-plugin
module.exports = {"link":"Item_link__1F8Xi","p":"Item_p__ZwvSU","blink-out":"Item_blink-out__3yYtN","span":"Item_span__3vpT9","blink-in":"Item_blink-in__1oSq_"};